import { sendPaywallEventDeferred } from "./paywallAnalytics";
let sequence = 0;

const normalizeWallet = value => ({ applePay: "apple_pay", googlePay: "google_pay", apple_pay: "apple_pay", google_pay: "google_pay", link: "link" })[value] || "unknown";
// One tracker per Stripe PaymentRequest, never shared between button surfaces.
export function createWalletInteractionAnalytics(payload) {
  let interaction;
  let availableType = "unknown";
  const start = () => ({ id: `${Date.now().toString(36)}-${++sequence}-${Math.random().toString(36).slice(2, 10)}`, authorized: false, dismissed: false, walletType: availableType });
  const emit = (eventName, extra = {}) => {
    try { sendPaywallEventDeferred(eventName, { paymentPath: "wallet", payload: {
      ...payload, wallet_attempt_id: interaction.id, wallet_type: interaction.walletType, ...extra,
    } }); } catch (_) {}
  };
  return {
    available(result) {
      const types = Object.entries(result || {}).filter(([key, value]) => value === true && normalizeWallet(key) !== "unknown").map(([key]) => normalizeWallet(key));
      // Availability is not evidence of which wallet was chosen when ambiguous.
      availableType = types.length === 1 ? types[0] : "unknown";
    },
    clicked() { interaction = start(); emit("wallet_button_clicked"); },
    authorized(walletType) {
      interaction ||= start(); interaction.authorized = true;
      const confirmed = normalizeWallet(walletType);
      if (confirmed !== "unknown") interaction.walletType = confirmed;
      emit("wallet_payment_authorized");
    },
    dismissed() {
      if (!interaction || interaction.dismissed) return;
      interaction.dismissed = true;
      // Stripe may emit cancel AFTER paymentmethod; do not label it a failure.
      emit("wallet_sheet_dismissed", { authorization_received: interaction.authorized });
    },
  };
}
